import { render } from "./StudentTable.vue?vue&type=template&id=67b87d99&scoped=true"
import script from "./StudentTable.vue?vue&type=script&lang=js"
export * from "./StudentTable.vue?vue&type=script&lang=js"

import "./StudentTable.vue?vue&type=style&index=0&id=67b87d99&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\pc\\Documents\\projets\\school_app_front_novation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b87d99"]])

export default __exports__